import React, {useState} from "react";
import images, {getRandomImage} from "../images";
import "./WifeStat.css";
import people from "../people/people";
import constants from "../constants";
import variables from "../variables";
import Missions from "./Missions";
import Contacts from "./Contacts";
import {Container, Row, Col} from "react-bootstrap";
import {useDispatch} from "react-redux";
import Name from "../../features/Name";
import i18next from "i18next";
import {toast} from "react-toastify";
import Image from "../../features/Image";

const WifeStat = () => {
    const dispatch = useDispatch();
    const [displayed, setDisplayed] = useState("Occupation");
    const [appearanceDisplayed, setAppearanceDisplayed] = useState("Appearance")
    const [appearanceContent, setAppearanceContent] = useState(images.wife.occupations.appearance[people.wife.appearance]);
    const [phoneContent, setPhoneContent] = useState("main");
    const [imgSrc, setImgSrc] = useState("");

    const onSideMenuButtonClick = e => {
        setPhoneContent("main");
        setDisplayed(e.target.dataset.name);
    };

    const onGalleryButtonClick = e => {
        setImgSrc(getRandomImage(images.wife.phone.gallery));
        setPhoneContent("gallery");
    };

    const onAppearanceMenuItemClick = e => {
        setAppearanceDisplayed(e.target.dataset.name);
        e.target.dataset.name === "Appearance" &&
            setAppearanceContent(images.wife.occupations.appearance[people.wife.appearance]);
        e.target.dataset.name === "Face" &&
            setAppearanceContent(images.wife.occupations.appearance.face[variables.wife.appearanceOther.face]);
        e.target.dataset.name === "Dress" &&
            setAppearanceContent(images.wife.occupations.appearance.dress[variables.wife.appearanceOther.dress]);
        e.target.dataset.name === "Bra" &&
            setAppearanceContent(images.wife.occupations.appearance.bra[variables.wife.appearanceOther.bra]);
        e.target.dataset.name === "Underpants" &&
            setAppearanceContent(images.wife.occupations.appearance.underpants[variables.wife.appearanceOther.underpants]);
    };

    const onContactsButtonClick = e => {
        setPhoneContent("contacts");
    };

    const onInstagramButtonClick = e => {
        toast(`${people.wife.getName()} has no Instagram... for now...`);
    };

    const getPhoneContent = () => {
        if (phoneContent === "main")
            return <Image className="center" src={images.wife.phone.cover[people.wife.phone]}/>
        else if (phoneContent === "gallery")
            return <Image className="center" src={imgSrc}/>
        else if (phoneContent === "contacts")
            return <Contacts/>
    };

    const Appearance = <Container fluid>
        <Row><h1>Appearance</h1></Row>
        <Row className="appearance">
            <Col lg={6}>
                <h3 className="section-subheader">{appearanceDisplayed}</h3>
                <Image className="center" src={appearanceContent}/>
            </Col>
            <Col lg={{span: 5, offset: 1}}>
                <h3>Sections</h3>
                {["Appearance", "Face", "Dress", "Bra", "Underpants"].map((item, key) => (
                    <Col sm={4} md={11} lg={12} key={key}>
                        <div
                            className={appearanceDisplayed === item ? "wife-btn selected" : "wife-btn"}
                            data-name={item}
                            onClick={onAppearanceMenuItemClick}
                        >{item}</div>
                    </Col>
                ))}
            </Col>
        </Row>
    </Container>

    const Occupation = <div className="occupation">
        <h1>{i18next.t("other.menus.occupation")}</h1>
        <div className="wife-stat">
            <div style={{alignSelf: "auto", marginLeft: 0}}>
                <Image className="center" src={people.wife.occupations.get().image}/>
            </div>
            <div className="desc">
                <div>
                    {people.wife.occupations.get().caption !== "" ?
                        <div>
                            <Name who={people.wife} noStyle/> {i18next.t(people.wife.occupations.get().caption)} {i18next.t("other.now")}.
                        </div> :
                        <div/>
                    }
                </div>
            </div>
        </div>
    </div>

    const Phone = <Container fluid className="phone">
        <Row><h1>Phone</h1></Row>
        <Row className="wife-stat">
            <Col lg={5} className="phone-picture">{getPhoneContent()}</Col>
            <Col lg={{span: 5, offset: 1}}>
                <h3>Actions</h3>
                <Col sm={4} md={11} lg={12}>
                    <div className="wife-btn get-random" onClick={onGalleryButtonClick}>Check random photo from gallery</div>
                    <div className="wife-btn" onClick={onContactsButtonClick}>Check Contacts</div>
                    <div className="wife-btn" onClick={onInstagramButtonClick}>Check Instagram</div>
                </Col>
            </Col>
        </Row>
    </Container>

    const Information = <Container fluid>
        <Row><h1>Information</h1></Row>
        <Row className="info">
            <Col lg={6}>
                <div className="home" style={{margin: "10px 5px 5px 5px"}}>
                    <b>Current home:</b> {constants.homes[variables.game.home].name}
                </div>
                <div><Image className="center home" src={images.places.homes[variables.game.home].homeMain}/></div>
                <div className="car" style={{margin: "10px 5px 5px 5px"}}>
                    <b>Current car:</b> {constants.cars[variables.game.car].name}
                </div>
                <div><Image className="center car" src={images.player.cars[variables.game.car]}/></div>
            </Col>
            <Col lg={{span: 5, offset: 1}}><Missions/></Col>
        </Row>
    </Container>

    return (
        <Container className="wife-stat">
            <Row>
                <Col sm={4} md={4} lg={3} className="side-bar">
                    <div className="buttons">
                        <Row style={{marginTop: "1em"}}>
                            {["Information", "Occupation", "Appearance", "Phone"].map((item, key) => (
                                <Col xs={4} sm={4} md={12} lg={12} key={key}>
                                    <div
                                        className={displayed === item ? "wife-btn selected" : "wife-btn"}
                                        data-name={item}
                                        onClick={onSideMenuButtonClick}
                                    >{item}</div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </Col>
                <Col sm={8} lg={{ span: 7, offset: 1 }} md={{ span: 7, offset: 1 }} style={{justifyContent: "center"}}>
                    <div className="main-content">
                        {displayed === "Information" && Information}
                        {displayed === "Appearance" && Appearance}
                        {displayed === "Occupation" && Occupation}
                        {displayed === "Phone" && Phone}
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default WifeStat;